<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('ruleForm')"
            >保存
            </el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              class="eidt-el-form el-form-wrap"
          >
            <div class="line-box">
              <el-form-item label="注册类型:" prop="type">
                <el-select
                    placeholder="注册类型:"
                    clearable
                    @change="getChageType"
                    v-model="ruleForm.type"
                    class="el-input-position"
                >
                  <el-option
                      v-for="(item, index) in types"
                      :key="index"
                      :label="item.name"
                      :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="注册状态:">
                <el-radio-group
                    v-model="ruleForm.disabled"
                    @change="getChageRadio"
                >
                  <el-radio :label="0">启用</el-radio>
                  <el-radio :label="1">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否审核:">
                <el-radio-group
                    v-model="ruleForm.verify"
                    @change="getVerifyRadio"
                >
                  <el-radio :label="0">禁用</el-radio>
                  <el-radio :label="1">启用</el-radio>
                </el-radio-group>
                <!--                <p>-->
                <!--                  <span style="margin-left: -72px;padding-right: 12px;color: #616266">是否接待:</span>-->
                <!--                  <el-radio-group v-model="ruleForm.isReception">-->
                <!--                    <el-radio :label="0">禁用</el-radio>-->
                <!--                    <el-radio :label="1">启用</el-radio>-->
                <!--                  </el-radio-group>-->
                <!--                </p>-->
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="证件类型:" prop="documentTypeId">
                <el-select
                    v-model="ruleForm.documentTypeId"
                    placeholder="选择证件类型"
                >
                  <el-option label="自动生成" value="0"></el-option>
                  <el-option
                      v-for="(type, index) in DocumentType"
                      :label="type.name"
                      :key="index"
                      :value="type.documentTypeId"
                  > {{ type.name }}
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="英文注册:">
                <el-radio-group
                    v-model="ruleForm.english"
                    @change="getEnglishRadio"
                >
                  <el-radio :label="0">禁用</el-radio>
                  <el-radio :label="1">启用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="注册类型:">
                <el-radio-group
                    v-model="ruleForm.wechat"
                    @change="getWechatRadio"
                >
                  <el-radio :label="0">普通</el-radio>
                  <el-radio :label="1">{{ this.wechat ? '微信' : '多人' }}</el-radio>
                  <!--                  <el-radio :label="2">团组</el-radio>-->
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="标题名称:" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <el-form-item label="展示二维码:">
                <el-radio-group
                    v-model="ruleForm.qrCode">
                  <el-radio :label="1">展示</el-radio>
                  <el-radio :label="0">不展示</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="白名单模式:">
                <el-radio-group
                    v-model="ruleForm.whitelist">
                  <el-radio :label="0">禁用</el-radio>
                  <el-radio :label="1">启用</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="同行人员:">
                <el-radio-group
                    v-model="ruleForm.isEntourage"
                >
                  <el-radio :label="0">禁用</el-radio>
                  <el-radio :label="1">启用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="信息重复提交:">
                <el-radio-group
                    v-model="ruleForm.isEdit"
                >
                  <el-radio :label="0">禁用</el-radio>
                  <el-radio :label="1">启用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="动态二维码:" prop="sms">
                <el-radio-group
                    v-model="ruleForm.validator"
                >
                  <el-radio :label="0">禁用</el-radio>
                  <el-radio :label="1">启用</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="接待模块:">
                <el-radio-group v-model="ruleForm.isReception">
                  <el-radio :label="0">禁用</el-radio>
                  <el-radio :label="1">启用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="身份证唯一校验:">
                <el-radio-group v-model="ruleForm.isIdVerify">
                  <el-radio :label="0">禁用</el-radio>
                  <el-radio :label="1">启用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="身份证验证:">
                <el-radio-group
                    v-model="ruleForm.verifyIdCard"
                >
                  <el-radio :label="0">不校验</el-radio>
                  <el-radio :label="1">三要素</el-radio>
                  <el-radio :label="2">二要素</el-radio>
                  <el-radio :label="3">身份证</el-radio>
                  <el-radio :label="4">中码验证</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="禁止新增:">
                <el-radio-group v-model="ruleForm.closeAdd">
                  <el-radio :label="0">关闭</el-radio>
                  <el-radio :label="1">开启</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="banner" :label="imgTitle">
                <el-input v-model="ruleForm.banner"></el-input>
              </el-form-item>
              <el-form-item prop="bannerMoblie" :label="imgTitle1">
                <el-input v-model="ruleForm.bannerMoblie"></el-input>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item
                  label="英文名称:"
                  prop="englishName"
              >
                <el-input v-model="ruleForm.englishName"></el-input>
              </el-form-item>
              <el-form-item prop="banner" :label="imgTitle">
                <UploadImg
                    @uploadImg="getUploadImg"
                    :editImg="editImg"
                ></UploadImg>
              </el-form-item>
              <el-form-item prop="bannerMoblie" :label="imgTitle1">
                <UploadImg
                    @uploadImg="getUploadImg1"
                    :editImg="editImg1"
                ></UploadImg>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="注册登录文本" prop="email">
                <el-input
                    v-model="ruleForm.email"
                ></el-input>
              </el-form-item>
              <el-form-item label="白名单通知内容" prop="sms">
                <el-input
                    v-model="ruleForm.sms"
                    type="textarea"
                    rows="4"
                ></el-input>
              </el-form-item>
              <el-form-item label="页面JS代码" prop="email">
                <el-input
                    v-model="ruleForm.viewPage"
                    type="textarea"
                    rows="4"
                ></el-input>
              </el-form-item>
            </div>
            <div class="line-box">
              <el-form-item label="团队功能:">
                <el-radio-group v-model="ruleForm.isTeam">
                  <el-radio :label="0">关闭</el-radio>
                  <el-radio :label="1">开启</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="支付开关:">
                <el-radio-group
                    v-model="ruleForm.pay"
                >
                  <el-radio :label="0">关</el-radio>
                  <el-radio :label="1">开</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="支付金额:">
                <el-input-number :max="999999" :min="0" v-model="ruleForm.price"></el-input-number>
              </el-form-item>
            </div>
          </el-form>
          <el-divider content-position="left">注册属性</el-divider>
          <el-form
              ref="tableData"
              :model="list"
              :rules="rules1"
              class="demo-ruleForm"
          >
            <el-button
                style="float: right; margin-left: 10px"
                type="primary"
                @click="save"
            >保存属性
            </el-button
            >
            <el-button
                style="float: right; margin-left: 10px"
                type="primary"
                plain
                @click="addRow"
            >新增属性
            </el-button
            >
            <el-table
                :data="list.tableData"
                style="width: 100%; margin-bottom: 30px; z-index: 1"
            >
              <el-table-column label="类型" width="160">
                <template slot-scope="scope">
                  <el-form-item
                      :prop="'tableData.' + scope.$index + '.type'"
                      :rules="rules1.type"
                  >
                    <el-select
                        placeholder="属性类型"
                        clearable
                        @change="selectChange"
                        v-model="scope.row.type"
                        class="el-input-position"
                    >
                      <el-option
                          v-for="(item, index) in inputTypes"
                          :key="index"
                          :label="item.name"
                          :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column width="100" label="排序">
                <template slot-scope="scope" prop="indexNo">
                  <el-form-item
                      :prop="'tableData.' + scope.$index + '.indexNo'"
                      :rules="rules1.indexNo"
                  >
                    <el-input
                        v-model="scope.row.indexNo"
                        style="width: 65px"
                        type="number"
                        min="1"
                        minlength="1"
                        maxlength="2"
                        @change="indexChange()"
                        max="99"
                        class="el-input"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="必填" width="150">
                <template slot-scope="scope" prop="required">
                  <el-form-item
                      v-show="scope.row.type >= 0"
                      :prop="'tableData.' + scope.$index + '.required'"
                      :rules="rules1.required"
                  >
                    <el-radio-group
                        v-show="scope.row.type >= 0"
                        v-model="scope.row.required"
                    >
                      <el-radio :label="0">否</el-radio>
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">只读</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="key" width="200">
                <template slot-scope="scope" prop="input">
                  <el-form-item
                      v-show="scope.row.type >= 0"
                      :prop="'tableData.' + scope.$index + '.name'"
                      :rules="rules1.input"
                  >
                    <el-autocomplete
                        v-show="scope.row.type >= 0"
                        v-model="scope.row.input"
                        clearable
                        @select="
                        (item) => {
                          handleSelect(item, scope.$index);
                        }
                      "
                        :fetch-suggestions="querySearch"
                        placeholder="属性 key 请填写英文"
                        class="el-input-position"
                        popper-class="my-autocomplete"
                    >
                      <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                      <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                        <span class="addr">{{ item.name }}</span>
                      </template>
                    </el-autocomplete>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="名称" width="200">
                <template slot-scope="scope" prop="name">
                  <el-form-item
                      v-show="scope.row.type >= 0"
                      :prop="'tableData.' + scope.$index + '.name'"
                      :rules="rules1.name"
                  >
                    <el-input
                        v-show="scope.row.type >= 0"
                        v-model="scope.row.name"
                        :type="scope.row.type == 0 ? 'textarea' : 'text'"
                        clearable
                        placeholder="中文名"
                        class="el-input-position"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                      v-show="scope.row.type >= 0 && ruleForm.english == 1"
                      :prop="'tableData.' + scope.$index + '.englishName'"
                      :rules="rules1.englishName"
                  >
                    <el-input
                        v-show="scope.row.type >= 0 && ruleForm.english == 1"
                        v-model="scope.row.englishName"
                        placeholder="英文名"
                        clearable
                        :type="scope.row.type == 0 ? 'textarea' : 'text'"
                        class="el-input-position"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                      v-show="scope.row.type >= 0 && ruleForm.english == 1"
                      :prop="'tableData.' + scope.$index + '.traditionalName'"
                      :rules="rules1.traditionalName"
                  >
                    <el-input
                        v-show="scope.row.type >= 0 && ruleForm.english == 1"
                        v-model="scope.row.traditionalName"
                        placeholder="繁体名"
                        clearable
                        :type="scope.row.type == 0 ? 'textarea' : 'text'"
                        class="el-input-position"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="选项">
                <template slot-scope="scope" prop="options">
                  <el-form-item
                      v-show="
                      scope.row.type >= 0 &&
                      (scope.row.type == '2' ||
                        scope.row.type == '20' ||
                        scope.row.type == '21' ||
                        scope.row.type == '4' ||
                        scope.row.type == '0' ||
                        scope.row.type == '17'||
                        scope.row.type == '24')
                    "
                      :prop="'tableData.' + scope.$index + '.options'"
                      :rules="rules1.option"
                  >
                    <!--                    <span v-show="scope.row.type == '17'">宽度:</span>-->
                    <!--                    <el-input-number-->
                    <!--                        v-show="scope.row.type == '17'"-->
                    <!--                        v-model="scope.row.options"-->
                    <!--                        placeholder="宽度"-->
                    <!--                        clearable-->
                    <!--                        class="el-input-position"-->
                    <!--                    ></el-input-number>-->
                    <!--                    </br>-->
                    <!--                    <span v-show="scope.row.type == '17'">高度:</span>-->
                    <!--                    <el-input-number-->
                    <!--                        v-show="scope.row.type == '17'"-->
                    <!--                        v-model="scope.row.englishOption"-->
                    <!--                        placeholder="高度"-->
                    <!--                        clearable-->
                    <!--                        class="el-input-position"-->
                    <!--                    ></el-input-number>-->
                    <el-input
                        v-show="
                        scope.row.type == '2' ||
                        scope.row.type == '20' ||
                        scope.row.type == '21' ||
                        scope.row.type == '4' ||
                        scope.row.type == '0'||
                        scope.row.type == '24'
                      "
                        v-model="scope.row.options"
                        type="textarea"
                        placeholder="中文选项|分割选项"
                        clearable
                        class="el-input-position"
                    ></el-input
                    >
                    <el-input
                        v-show="
                        scope.row.type == '2' ||
                        scope.row.type == '20' ||
                        scope.row.type == '21' ||
                        scope.row.type == '4' ||
                        scope.row.type == '0'||
                        scope.row.type == '24'
                      "
                        v-model="scope.row.englishOption"
                        type="textarea"
                        placeholder="英文选项:根据|分割选项"
                        clearable
                        class="el-input-position"
                    ></el-input
                    >
                    <el-input
                        v-show="
                        scope.row.type == '2' ||
                        scope.row.type == '20' ||
                        scope.row.type == '21' ||
                        scope.row.type == '4' ||
                        scope.row.type == '0' ||
                        scope.row.type == '24'
                      "
                        v-model="scope.row.traditionalOption"
                        type="textarea"
                        placeholder="繁体选项:根据|分割选项"
                        clearable
                        class="el-input-position"
                    ></el-input>

                    <!--                    <p v-for="(option, b) in scope.row.optionsAndLabels">-->
                    <!--                      <el-card-->
                    <!--                          class="box-card"-->
                    <!--                          v-show="-->
                    <!--                          scope.row.type >= 0 &&-->
                    <!--                          (scope.row.type == '2' ||-->
                    <!--                            scope.row.type == '4' ||-->
                    <!--                            scope.row.type == '0')-->
                    <!--                        "-->
                    <!--                      >-->
                    <!--&lt;!&ndash;                    <p style="white-space: normal">&ndash;&gt;-->
                    <!--&lt;!&ndash;                      选项{{ b + 1 }}&ndash;&gt;-->
                    <!--&lt;!&ndash;                      <el-button&ndash;&gt;-->
                    <!--&lt;!&ndash;                          style="float: right"&ndash;&gt;-->
                    <!--&lt;!&ndash;                          class="btn-small"&ndash;&gt;-->
                    <!--&lt;!&ndash;                          @click="del(scope.row, b)"&ndash;&gt;-->
                    <!--&lt;!&ndash;                          type="danger"&ndash;&gt;-->
                    <!--&lt;!&ndash;                      >×&ndash;&gt;-->
                    <!--&lt;!&ndash;                      </el-button&ndash;&gt;-->
                    <!--&lt;!&ndash;                      >&ndash;&gt;-->
                    <!--&lt;!&ndash;                    </p>&ndash;&gt;-->
                    <!--                    <el-select-->
                    <!--                        :filter-method="dataFilter"-->
                    <!--                        v-model="option.label"-->
                    <!--                        placeholder="选择标签"-->
                    <!--                    >-->
                    <!--                      <el-option-->
                    <!--                          v-for="label in labels"-->
                    <!--                          :label="label.name"-->
                    <!--                          :value="label.name"-->
                    <!--                      >-->
                    <!--                      </el-option>-->
                    <!--                    </el-select>-->
                    <!--                    <el-input-->
                    <!--                        v-model="option.option"-->
                    <!--                        type="textarea"-->
                    <!--                        rows="1"-->
                    <!--                        clearable-->
                    <!--                        :autosize="{ minRows: 1, maxRows: 10 }"-->
                    <!--                        class="el-input-position"-->
                    <!--                        placeholder="中文选项"-->
                    <!--                    ></el-input>-->

                    <!--                    <el-input-->
                    <!--                        rows="1"-->
                    <!--                        v-model="option.englishOption"-->
                    <!--                        clearable-->
                    <!--                        type="textarea"-->
                    <!--                        :autosize="{ minRows: 1, maxRows: 10 }"-->
                    <!--                        class="el-input-position"-->
                    <!--                        placeholder="英文选项"-->
                    <!--                    ></el-input>-->

                    <!--                    <el-input-->
                    <!--                        type="textarea"-->
                    <!--                        v-model="option.traditionalOption"-->
                    <!--                        clearable-->
                    <!--                        :autosize="{ minRows: 1, maxRows: 10 }"-->
                    <!--                        rows="1"-->
                    <!--                        class="el-input-position"-->
                    <!--                        placeholder="中文繁体选项"-->
                    <!--                    ></el-input>-->
                    <!--                    </el-card>-->
                    <!--                    </p>-->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column width="150" label="操作">
                <template slot-scope="scope">
                  <!--                  <el-button-->
                  <!--                      v-show="-->
                  <!--                                        scope.row.type >= 0 &&-->
                  <!--                                        (scope.row.type == '2' ||-->
                  <!--                                          scope.row.type == '4' ||-->
                  <!--                                          scope.row.type == '0')-->
                  <!--                                      "-->
                  <!--                      type="success"-->
                  <!--                      plain-->
                  <!--                      @click="add(scope.$index, scope.row)"-->
                  <!--                  >添加选项-->
                  <!--                  </el-button-->
                  <!--                  >-->
                  <el-button
                      type="danger"
                      plain
                      @click="deleterow(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
              <el-table-column width="10"></el-table-column>
            </el-table>
          </el-form>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
function sortBy(props) {
  return function (a, b) {
    return a[props] - b[props];
  };
}

function filterOne(dataList, value, type) {
  var s = dataList.filter(function (item, index, arr) {
    for (let j = 0; j < type.length; j++) {
      if (item[type[j]] != undefined || item[type[j]] != null) {
        if (item[type[j]].indexOf(value) >= 0) {
          return item;
        }
      }
    }
  });
  return s;
}

var inputTypes = [
  {name: "分页-下一步", value: "-1"},
  {name: "联系方式", value: "25"},
  {name: "身份证和其他", value: "26"},
  {name: "团队/公司", value: "27"},
  {name: "是否单选", value: "28"},
  {name: "提交", value: "-2"},
  {name: "团组邀请码", value: "23"},
  {name: "免责条款", value: "24"},
  {name: "文本框", value: "1"},
  {name: "单选框", value: "2"},
  {name: "下拉框", value: "20"},
  {name: "预填文本", value: "21"},
  {name: "文本域", value: "3"},
  {name: "多选框", value: "4"},
  {name: "电话框", value: "9"},
  {name: "验证码", value: "10"},
  {name: "身份证", value: "15"},
  {name: "有效证件", value: "22"},
  {name: "身份证/姓名", value: "16"},
  {name: "上传头像并截取", value: "17"},
  {name: "白名单验证码", value: "19"},
  {name: "日期框", value: "6"},
  {name: "时间框", value: "7"},
  {name: "数字框", value: "8"},
  {name: "电子邮箱", value: "5"},
  {name: "地区", value: "11"},
  {name: "性别", value: "12"},
  {name: "上传图片", value: "13"},
  {name: "邀请码", value: "14"},
  {name: "国家", value: "18"},
  {name: "长标题-多选", value: "0"},
];

var types = [
  {name: "组委会", value: "1"},
  {name: "展商", value: "2"},
  {name: "展团/代表团", value: "3"},
  {name: "观众", value: "4"},
  {name: "媒体", value: "5"},
  {name: "嘉宾", value: "6"},
  {name: "搭建商", value: "7"},
  {name: "服务商", value: "8"},
  {name: "撤展人员", value: "9"},
  {name: "兼职/志愿者/外协", value: "10"},
  {name: "会议/论坛/活动", value: "11"},
  {name: "其他", value: "12"},
];

var array = [
  {value: "team", name: "团队/公司", type: "27"},
  {value: "免责条款", name: "免责条款", type: "24"},
  {value: "联系方式", name: "remark", type: "25"},
  {value: "idCard", name: "身份证和其他", type: "26"},
  {value: "phone", name: "手机号码", type: "9"},
  {value: "name", name: "名称", type: "1"},
  {value: "avatar", name: "上传头像", type: "13"},
  {value: "idCard", name: "身份证号", type: "1"},
  {value: "verifycode", name: "验证码", type: "10"},
  {value: "company", name: "公司", type: "1"},
  {value: "position", name: "职务", type: "1"},
  {value: "area", name: "地区", type: "11"},
  {value: "address", name: "地址", type: "3"},
  {value: "email", name: "电子邮箱", type: "5"},
  {value: "sex", name: "性别", type: "12"},
  {value: "code", name: "邀请码", type: "14"},
  {value: "verifycode", name: "行程码", type: "15"},
  {value: "idCard", name: "核酸", type: "16"},
  {value: "openId", name: "标签", type: "1"},
  {value: "nameEn", name: "英文名", type: "1"},
  {value: "companyEn", name: "公司英文", type: "1"},
  {value: "positionEn", name: "职务英文", type: "1"},
  {value: "roomNo", name: "房间号", type: "1"},
  {value: "countryArea", name: "国家/地区", type: "18"},
  {value: "province", name: "省份", type: "1"},
  {value: "city", name: "城市", type: "1"},
  {value: "addressEn", name: "地址英文", type: "1"},
  {value: "booth", name: "展位", type: "1"},
  {value: "visit", name: "座位号", type: "1"},
  {value: "status", name: "目标市场", type: "1"},
  {value: "market", name: "参加论坛", type: "1"},
  {value: "business", name: "业务范围", type: "1"},
  {value: "profile", name: "行政级别", type: "1"},
  {value: "documentType", name: "证件类型", type: "1"},
  {value: "remark", name: "备注", type: "1"},
  {value: "remark1", name: "备注1", type: "1"},
  {value: "remark2", name: "备注2", type: "1"},
  {value: "remark3", name: "备注3", type: "1"},
  {value: "remark4", name: "备注4", type: "1"},
  {value: "remark5", name: "备注5", type: "1"},
];

var array1 = [
  {value: "team", name: "团队/公司", type: "27"},
  {value: "entourageName", name: "陪同人员姓名", type: "1"},
  {value: "entouragePhone", name: "陪同人员手机", type: "1"},
  {value: "entourageEmail", name: "陪同人员邮箱", type: "1"},
  {value: "arrivalMethod", name: "抵达方式", type: "20"},
  {value: "arrivalLocation", name: "抵达地点", type: "20"},
  {value: "arrivalDate", name: "抵达日期", type: "6"},
  {value: "arrivalTime", name: "抵达时间", type: "7"},
  {value: "arrivalGrades", name: "抵达班次(高铁/飞机)", type: "1"},
  {value: "isReception", name: "是否接机接站", type: "28"},
  {value: "receivedName", name: "接机人姓名", type: "1"},
  {value: "receivedPhone", name: "接机人手机", type: "1"},
  {value: "receivedCar", name: "接机人车型", type: "1"},
  {value: "receivedCarNo", name: "接机人车牌", type: "1"},
  {value: "isGive", name: "是否送机送站", type: "28"},
  {value: "giveDate", name: "送机送站日期", type: "6"},
  {value: "giveTime", name: "送机送站时间", type: "7"},
  {value: "giveMethod", name: "送机送站方式", type: "20"},
  {value: "giveLocation", name: "送机送站地点", type: "20"},
  {value: "giveGrades", name: "送机班次(高铁/飞机)", type: "1"},
  {value: "giveName", name: "送机人姓名", type: "1"},
  {value: "givePhone", name: "送机人手机", type: "1"},
  {value: "giveCar", name: "送机人车型", type: "1"},
  {value: "giveCarNo", name: "送机人车牌", type: "1"},
  {value: "isCheckIn", name: "是否入住酒店", type: "28"},
  {value: "hotel", name: "酒店名称", type: "20"},
  {value: "roomType", name: "房间类型", type: "20"},
  {value: "roomNo", name: "房间号", type: "1"},
  {value: "checkInTime", name: "酒店入住日期", type: "6"},
  {value: "departureTime", name: "酒店离开日期", type: "6"},
  {value: "免责条款", name: "免责条款", type: "24"},
  {value: "联系方式", name: "remark", type: "25"},
  {value: "idCard", name: "身份证和其他", type: "26"},
  {value: "phone", name: "手机号码", type: "9"},
  {value: "name", name: "名称", type: "1"},
  {value: "avatar", name: "上传头像", type: "13"},
  {value: "idCard", name: "身份证号", type: "1"},
  {value: "verifycode", name: "验证码", type: "10"},
  {value: "company", name: "公司", type: "1"},
  {value: "position", name: "职务", type: "1"},
  {value: "area", name: "地区", type: "11"},
  {value: "address", name: "地址", type: "3"},
  {value: "email", name: "电子邮箱", type: "5"},
  {value: "sex", name: "性别", type: "12"},
  {value: "code", name: "邀请码", type: "14"},
  {value: "verifycode", name: "行程码", type: "15"},
  {value: "idCard", name: "核酸", type: "16"},
  {value: "openId", name: "标签", type: "1"},
  {value: "nameEn", name: "英文名", type: "1"},
  {value: "companyEn", name: "公司英文", type: "1"},
  {value: "positionEn", name: "职务英文", type: "1"},
  {value: "roomNo", name: "房间号", type: "1"},
  {value: "countryArea", name: "国家/地区", type: "18"},
  {value: "province", name: "省份", type: "1"},
  {value: "city", name: "城市", type: "1"},
  {value: "addressEn", name: "地址英文", type: "1"},
  {value: "booth", name: "展位", type: "1"},
  {value: "visit", name: "座位号", type: "1"},
  {value: "status", name: "目标市场", type: "1"},
  {value: "market", name: "参加论坛", type: "1"},
  {value: "business", name: "业务范围", type: "1"},
  {value: "profile", name: "行政级别", type: "1"},
  {value: "documentType", name: "证件类型", type: "1"},
  {value: "remark", name: "备注", type: "1"},
  {value: "remark1", name: "备注1", type: "1"},
  {value: "remark2", name: "备注2", type: "1"},
  {value: "remark3", name: "备注3", type: "1"},
  {value: "remark4", name: "备注4", type: "1"},
  {value: "remark5", name: "备注5", type: "1"}
];

import UploadImg from "../public/UploadImg";

export default {
  name: "editvihicel",
  data() {
    return {
      labels: [],
      optionsCopy: [],
      rules: {
        englishName: [
          {required: false, message: "名称不能为空", trigger: "blur"},
        ],
        type: [{required: true, message: "类型不能为空", trigger: "blur"}],
        name: [{required: true, message: "名称不能为空", trigger: "blur"}],
        banner: [{required: false, message: "头部不能为空", trigger: "blur"}],
        bannerMobile: [
          {required: false, message: "头部不能为空", trigger: "blur"},
        ],
        documentTypeId: [
          {required: true, message: "证件类型不能为空", trigger: "blur"},
        ],
      },
      rules1: {
        input: [
          {required: false, message: "属性key不能为空", trigger: "blur"},
        ],
        type: [{required: true, message: "类型不能为空", trigger: "blur"}],
        name: [{required: false, message: "名称不能为空", trigger: "blur"}],
        indexNo: [{required: true, message: "排序不能为空", trigger: "blur"}],
        options: [
          {required: false, message: "选项不能为空", trigger: "blur"},
        ],
        englishOption: [
          {required: false, message: "英文选项不能为空", trigger: "blur"},
        ],
        englishName: [
          {required: false, message: "英文名称不能为空", trigger: "blur"},
        ],
        traditionalOption: [
          {required: false, message: "繁体选项不能为空", trigger: "blur"},
        ],
        traditionalName: [
          {required: false, message: "繁体名称不能为空", trigger: "blur"},
        ],
      },
      inputTypes: inputTypes,
      types: types,
      projectId: localStorage.getItem("project_Id"),
      DocumentType: [],
      gb: window.location.hostname.indexOf("gb") > -1,
      wechat: window.location.hostname.indexOf("gb") > -1 ? false : true,
      ruleForm: {
        isTeam: 0,
        whitelist: 0,
        validator: 0,
        verifyIdCard: 0,
        isEdit: 0,
        isEntourage: 0,
        isReception: 0,
        isIdVerify: 0,
        pay: 0,
        price: 0,
        documentTypeId: "0",
        lang: "",
        name: "",
        uploadFile: "",
        englishName: "",
        sms: "",
        email: "",
        viewPage: "",
        url: "",
        banner: "",
        bannerMoblie: "",
        disabled: 0,
        closeAdd: 0,
        english: 0,
        wechat: 0,
        verify: 0,
        qrCode: 1,
        type: "1",
        projectId: localStorage.getItem("project_Id"),
      },
      register_Id: "",
      editImg: "",
      editImg1: "",
      imgTitle: "二维码界面图片:",
      imgTitle1: "填表界面图片:",
      list: {
        tableData: [
          {
            indexNo: 1,
            propertyId: null,
            name: "手机号码",
            input: "phone",
            englishName: "phone",
            englishOption: "",
            type: "1",
            required: 0,
            options: "",
            traditionalOption: "",
            traditionalName: "",
            // optionsAndLabels: {
            //   index: 0,
            //   label: "",
            //   option: "",
            //   englishOption: "",
            //   traditionalOption: "",
            // },
          },
        ],
      },
    };
  },
  created() {
    this.getDocumentType();
    this.getLabel();
  },
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
  },
  watch: {
    editData: function () {
      if (this.editData) {
        this.ruleForm = this.editData;
        if (!this.ruleForm.validator) {
          this.ruleForm.validator = 0;
        } else {
          this.ruleForm.validator = parseInt(this.editData.validator);
        }
        if (!this.ruleForm.verifyIdCard) {
          this.ruleForm.verifyIdCard = 0;
        }
        this.ruleForm.type = this.editData.type.toString();
        this.register_Id = this.editData.registerId;
        this.editImg = this.editData.banner;
        this.editImg1 = this.editData.bannerMoblie;
        this.$axios
            .get("/Property/register/" + this.editData.registerId)
            .then((res) => {
              if (res.data.hasError == false) {
                this.list.tableData = [...res.data.data];
                for (var i = 0; i < this.list.tableData.length; i++) {
                  this.list.tableData[i].type =
                      this.list.tableData[i].type.toString();
                  this.list.tableData[i].optionsAndLabels = this.list.tableData[i]
                      .json
                      ? [...JSON.parse(this.decode(this.list.tableData[i].json))]
                      : [];
                }
              }
            });
      }
    },
  },
  methods: {
    dataFilter(val) {
      if (val) {
        //val存在
        this.options = this.optionsCopy.filter((item) => {
          if (
              !!~item.label.indexOf(val) ||
              !!~item.label.toUpperCase().indexOf(val.toUpperCase())
          ) {
            return true;
          }
        });
      } else {
        //val为空时，还原数组
        this.options = this.optionsCopy;
      }
    },
    getLabel() {
      this.$axios.get("/Label/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.labels = [...res.data.data];
          this.optionsCopy = [];
          for (let item of this.labels) {
            this.optionsCopy.push({label: item.name, value: item.name});
          }
        }
      });
    },
    getDocumentType() {
      this.$axios.get("/DocumentType/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.DocumentType = [...res.data.data];
        }
      });
    },
    handleSelect(item, filed) {
      this.list.tableData[filed].name = item.name;
      this.list.tableData[filed].englishName = item.value;
      this.list.tableData[filed].type = item.type;
    },
    querySearch(queryString, cb) {
      if (this.ruleForm.isReception == 1) {
        cb(filterOne(array1, queryString, ["value"]));
      } else {
        cb(filterOne(array, queryString, ["value"]));
      }
    }, //字符串转base64
    encode(str) {
      // 对字符串进行编码
      var encode = encodeURI(str);
      // 对编码的字符串转化base64
      var base64 = btoa(encode);
      return base64;
    },
    // base64转字符串
    decode(base64) {
      // 对base64转编码
      var decode = atob(base64);
      // 编码转字符串
      var str = decodeURI(decode);
      return str;
    },
    save() {
      this.$refs.tableData.validate((valid) => {
        var list = new Array();
        var list1 = new Array();
        for (var i = 0; i < this.list.tableData.length; i++) {
          if (
              this.list.tableData[i].input != null &&
              this.list.tableData[i].input != ""
          ) {
            if (parseInt(this.list.tableData[i].type) < 0) {
              this.list.tableData[i].required = 0;
            }
            if (list.includes(this.list.tableData[i].input)) {
              this.$message.error(
                  this.list.tableData[i].input + ",不能重复使用"
              );
              valid = false;
              break;
            } else {
              // if (
              //   "personalid,projectid,registerid,exhibitorid,openId,type,verify,issign,ispassage,createdate,signdate,passagedate,disabled".indexOf(
              //     this.list.tableData[i].input.toLowerCase()
              //   ) > 0
              // ) {
              //   this.$message.error(
              //     this.list.tableData[i].input +
              //       "为系统已使用关键词，不能重复使用"
              //   );
              //   valid = false;
              //   break;
              // }
            }
            list.push(this.list.tableData[i].input);
          } else {
            list1.push(this.list.tableData[i].type);
          }
        }
        // console.log(list1,list)
        // if (!list1.includes("-2")) {
        //   valid = false;
        //   this.$message.error("表单没有提交按钮");
        // }
        if (valid) {
          if (this.register_Id == "" || this.register_Id == undefined) {
            this.$message.error("请先保存注册信息");
          } else if (
              this.list.tableData == null ||
              this.list.tableData.length == 0
          ) {
            this.$message.error("请添加属性");
          } else {
            for (let option of this.list.tableData) {
              if (
                  option.optionsAndLabels &&
                  option.optionsAndLabels.length > 0
              ) {
                let options = [];
                let englishOptions = [];
                let traditionalOptions = [];
                let labels = [];
                option.optionsAndLabels.forEach((element) => {
                  if (element.option) options.push(element.option);
                  if (element.englishOption)
                    englishOptions.push(element.englishOption);
                  if (element.traditionalOption)
                    traditionalOptions.push(element.traditionalOption);
                  if (element.label) labels.push(element.label);
                });
                option.options = options.join("|");
                option.englishOption = englishOptions.join("|");
                option.traditionalOption = traditionalOptions.join("|");
                option.labels = labels.join("|");
                option.json = this.encode(
                    JSON.stringify(option.optionsAndLabels)
                );
              }
            }

            this.$axios
                .put("/Property/" + this.register_Id + "", this.list.tableData)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("编辑成功！");
                    // this.goBack();
                  } else {

                    this.$message.error(res.data.message);
                  }
                });
          }
        }
      });
    },
    saveClick(ruleForm) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.register_Id == "" || this.register_Id == undefined) {
            this.$axios.post("/Register/", this.ruleForm).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
                this.register_Id = res.data.data.registerId;
              } else {

                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios
                .put("/Register/" + this.register_Id + "", this.ruleForm)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("编辑成功！");
                    this.goBack();
                  } else {

                    this.$message.error(res.data.message);
                  }
                });
          }
        } else {
          return false;
        }
      });
    },
    indexChange() {
      this.list.tableData.sort(sortBy("indexNo"));
    },
    addRow() {
      this.list.tableData.push({
        propertyId: null,
        name: "",
        input: "",
        required: 0,
        type: "1",
        indexNo: this.list.tableData.length + 1,
        option: "",
        optionsAndLabels: [],
        englishOption: "",
        englishname: "",
        traditionalOption: "",
        traditionalName: "",
      });
    }, downloadUploadFile() {

    },
    download() {

    },
    upload() {

    },
    add(index, row) {
      this.list.tableData[index].optionsAndLabels.push({
        index: this.list.tableData[index].optionsAndLabels.length,
        label: "",
        option: "",
        englishOption: "",
        traditionalOption: "",
      });
    },
    deleterow(index, row) {
      this.list.tableData.splice(index, 1);
      for (var i = 0; i < this.list.tableData.length; i++) {
        this.list.tableData[index].indexNo = i + 1;
      }
    },
    goBack() {
      this.editData = null;
      this.register_Id = "";
      this.$emit("backFunStu");
      this.$refs.ruleForm.resetFields();
      this.editImg = "";
      this.editImg1 = "";
      this.list.tableData = [];
    },
    selectChange(val) {
    },
    getChageRadio(value) {
      this.ruleForm.disabled = value;
    },
    getChageType(val) {
      this.ruleForm.lang = this.types[val - 1].name;
    },
    getWechatRadio(value) {
      this.ruleForm.wechat = value;
    },
    getVerifyRadio(value) {
      this.ruleForm.verify = value;
    },
    getEnglishRadio(value) {
      this.ruleForm.english = value;
      if (value == 1) {
        rules.englishName.required = true;
        rules1.englishName.required = true;
        //rules1.englishOption.required=true;
      } else {
        rules.englishName.required = false;
        rules1.englishName.required = false;
        //rules1.englishOption.required=false;
      }
    },
    del(row, index) {
      row.optionsAndLabels.splice(index, 1);
    },
    getUploadImg(imgSrc) {
      this.ruleForm.banner = imgSrc;
    },
    getUploadImg1(imgSrc) {
      this.ruleForm.bannerMoblie = imgSrc;
    },
  },
  components: {
    UploadImg,
  },
};
</script>

<style lang="scss" scoped>
.el-form-wrap {
  width: 100% !important;
}

.line-box {
  display: flex;
  flex: 1;
}

.line-box .el-form-item,
.line-box .up-img {
  width: 40% !important;
}

.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>